import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import { signInByTrueIdFeatureModel } from '~/features/subscriber/sign-in'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { AuthLayout, SignInTrueIdForm } from '~/widgets/auth'
import { SignUpForm } from '~/widgets/auth/SignUpForm'

export function Title(): JSX.Element {
  return <AppTitle t='sign_up' />
}

SignUpPage.displayName = 'SignUpPage'
export function SignUpPage(): JSX.Element {
  const trueIdConfig = useUnit(signInByTrueIdFeatureModel.$trueIdConfig)

  return (
    <AuthLayout>
      {trueIdConfig ? <SignInTrueIdForm /> : <SignUpForm />}
    </AuthLayout>
  )
}
